import React from 'react'
import './Header.css'
import { useAuth } from '../../AuthProvider'
import { fullName, cap, initials } from '../../lib/lab'
import ScanBox from '../Scan/ScanBox'

const Header = () => {
    const { user, labRole } = useAuth();
    const name = fullName(user?.staff?.name);
    const subtitle = [cap(user?.staff?.staffType), labRole ? `${cap(labRole)}` : null].filter(Boolean).join(' · ');
    return (
        <div className='header_container'>
            <div className="profile-section">
                <div className="profile profile--initials">{initials(name) || 'L'}</div>
                <div className='dr-title'>
                    <h5>{name}</h5>
                    <span>{subtitle}</span>
                </div>
            </div>
            <ScanBox />
        </div>
    )
}

export default Header
